import React from "react";
import { map } from "lodash";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from "recharts";
import { HeatMapCapitalGainPoint } from "../../models/heatMapModel";

interface Props {
  data: HeatMapCapitalGainPoint[];
  currencySymbol?: string;
}

const MONTH_LABELS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

const ZoneTrends: React.FC<Props> = ({ data, currencySymbol = "$" }) => {
  if (!data.length) return null;

  const chartData = map(data, (d) => ({ ...d, label: MONTH_LABELS[d.month - 1] ?? d.month }));

  return (
    <div className="mb-2 md:mb-6">
      <p className="text-sm md:text-base font-semibold text-gray-900 mb-2 md:mb-3">Tendencias últimos 6 meses</p>
      <div className="bg-gray-100 rounded-xl p-2 md:p-4">
        <ResponsiveContainer width="100%" height={200}>
          <LineChart data={chartData} margin={{ top: 5, right: 20, left: -15, bottom: 0 }}>
            <CartesianGrid strokeDasharray="1 1" horizontal={false} stroke="#e5e7eb" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={{ stroke: "#d1d5db" }} tickLine={false} interval={0} />
            <YAxis domain={["auto", "auto"]} tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={{ stroke: "#d1d5db" }} tickLine={false} tickFormatter={(v: number) => parseFloat(v.toFixed(2)).toLocaleString("en-US")} />
            <Tooltip formatter={(v: number) => [`${currencySymbol}${v.toLocaleString("en-US")}`, "Precio m²"]} contentStyle={{ borderRadius: 8, fontSize: 13 }} />
            <Line type="monotone" dataKey="value" stroke="#212529" strokeWidth={2} dot={{ r: 4, fill: "#212529" }} activeDot={{ r: 6 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <p className="text-xs text-gray-500 my-1">
        Datos estimados con base en publicaciones y transacciones verificadas.
      </p>
    </div>
  );
};

export default ZoneTrends;
